import React from 'react';

export default function InsightsGridSection() {
    const gridCards = [
        {
            id: 1,
            title: "US Midwest Community Bank Transforms Lending Operations Through Consulting-led Modernization"
        },
        {
            id: 2,
            title: "Agentic AI Chatbot Enhancing Card Benefit Discovery and Utilization for a Global Payment Provider"
        },
        {
            id: 3,
            title: "US Midwest Community Bank Transforms Lending Operations Through Consulting-led Modernization"
        },
        {
            id: 4,
            title: "Agentic AI Chatbot Enhancing Card Benefit Discovery and Utilization for a Global Payment Provider"
        }
    ];

    return (
        <section className="bg-white py-12 sm:py-16 lg:py-24 select-none text-left relative z-10">
            <div className="max-w-[1440px] mx-auto px-[20px] lg:px-[80px] w-full space-y-6 lg:space-y-8">

                <div className="grid grid-cols-1 md:grid-cols-2 gap-6 lg:gap-8 w-full items-stretch">
                    {gridCards.map((card) => (
                        <div
                            key={card.id}
                            className="w-full bg-white border border-[#01386A45] p-6 sm:p-8 lg:p-[40px] flex flex-col justify-between min-h-[220px] sm:min-h-[361px] group cursor-pointer relative shadow-[0_4px_25px_rgba(0,0,0,0.01)] transition-all duration-500 hover:shadow-[0_15px_45px_rgba(0,0,0,0.04)]"
                        >
                            <h3 className="text-[#01386A] font-sora font-[600] text-[16px] lg:text-[20px] leading-[1.4] tracking-tight">
                                {card.title}
                            </h3>

                            <div className="pt-4 mt-auto">
                                <a
                                    href="#"
                                    className="inline-flex items-center gap-1.5 text-[13px] sm:text-[14px] font-[600] text-[#01386A] border-b-2 border-[#01386A] pb-0.5 transition-all duration-300  group/link"
                                >
                                    <span>Read More</span>
                                    <span className="transform transition-transform duration-300 group-hover/link:translate-x-1 text-orange-500 font-bold">
                                        &gt;
                                    </span>
                                </a>
                            </div>

                            <div className="absolute bottom-0 left-0 right-0 h-[4px] bg-[#01386A] z-20 overflow-hidden">
                                <div className="absolute inset-0 bg-orange-500 translate-x-[-100%] group-hover:translate-x-0 transition-transform duration-500 ease-out origin-left" />
                            </div>
                        </div>
                    ))}
                </div>

                <div className="w-full bg-gray-900 rounded-b-[4px] overflow-hidden group cursor-pointer relative min-h-[260px] sm:min-h-[320px] md:min-h-[360px] flex flex-col justify-between p-6 sm:p-10 lg:p-12 shadow-md">
                    <div className="absolute inset-0 z-0">
                        <img
                            src="/assets/insights/img6.png"
                            alt="Featured Banner"
                            className="w-full h-full object-cover transition-transform duration-700 ease-out group-hover:scale-103"
                        />
                    </div>

                    <div className="relative z-10 max-w-[551px] space-y-6 sm:space-y-8">
                        <h3 className="text-white font-sora font-[600] text-[16px] md:text-[20px] lg:leading-[32px] leading-[24px] tracking-tight">
                            Agentic AI Chatbot Enhancing Card Benefit Discovery and Utilization for a Global Payment Provider
                        </h3>

                    </div>
                    <div className="pt-2 relative z-10">
                        <a
                            href="#"
                            className="inline-flex items-center gap-1.5 text-[14px] sm:text-[16px] font-graphik font-[500] text-white border-b-2 border-white pb-0.5 transition-all duration-300 group/link"
                        >
                            <span>Read More</span>
                            <span className="transform transition-transform duration-300 group-hover/link:translate-x-1 text-orange-500 font-bold">
                                &gt;
                            </span>
                        </a>
                    </div>

                    <div className="absolute bottom-0 left-0 right-0 h-[4px] bg-[#01386A] z-20 overflow-hidden">
                        <div className="absolute inset-0 bg-orange-500 translate-x-[-100%] group-hover:translate-x-0 transition-transform duration-500 ease-out origin-left" />
                    </div>
                </div>

            </div>
        </section>
    );
}